import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock, Loader2, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { login, setToken } from "@/lib/api";

export default function Login() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/studio";

  const submit = async () => {
    if (!password.trim()) {
      toast.error("Enter the password.");
      return;
    }
    setLoading(true);
    try {
      const data = await login(password);
      setToken(data.token);
      toast.success("Welcome back.");
      navigate(from, { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Incorrect password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="w-full max-w-md border border-white/10 bg-card p-8 animate-rise">
        <Lock className="w-6 h-6 text-signal" />
        <h1 className="font-anton text-4xl uppercase tracking-tight mt-5 leading-none">
          Staff Access
        </h1>
        <p className="text-muted-foreground text-sm mt-3">
          The Editor's Desk, Advertorial Builder and Leads dashboard are
          password-protected. Enter the staff password to continue.
        </p>

        <label className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground block mt-7">
          Password
        </label>
        <input
          data-testid="login-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="••••••••"
          className="w-full mt-2 bg-background border border-white/15 px-4 py-3 text-foreground placeholder:text-muted-foreground/60 focus:border-signal outline-none font-sans"
        />

        <button
          data-testid="login-submit-btn"
          onClick={submit}
          disabled={loading}
          className="w-full mt-5 inline-flex items-center justify-center gap-2 bg-signal text-white font-mono text-xs uppercase tracking-widest px-6 py-3.5 hover:bg-signal-hover transition-colors disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowUpRight className="w-4 h-4" />}
          {loading ? "Checking…" : "Enter"}
        </button>
      </div>
    </div>
  );
}
